import cn from 'classnames';
import { useContext, useMemo } from 'react';

import Heading from 'components/common/Heading';
import Text from 'components/common/Text';
import Chat from 'components/icons/illustrative/Chat';
import Enjoy from 'components/icons/illustrative/Enjoy';
import Gift from 'components/icons/illustrative/Gift';
import { UserContext } from 'components/signUpFunnel/Contexts';
import { BrandContext } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';
import { ICON_SIZES } from 'lib/constants/iconSizes';
import style from 'styles/components/signUpFunnel/thankYou/InviteFriendsInstructions';

import { default as SmartphoneInviteFriendsInstructions } from './smartphone/InviteFriendsInstructions';

const InviteFriendsInstructions = ({ isSmartphoneScreenSize = false, isPickYourMeals = false }) => {
  const { brand } = useContext(BrandContext);

  const { user } = useContext(UserContext);

  const referralAmountFormatted = useMemo(() => {
    return user?.referralAmountFormatted;
  }, [user]);

  const giveToFriendText = useMemo(() => {
    if (user) {
      return `Gift your friends ${user.referralReceiverValue} when they sign up using your link.`;
    }
  }, [user]);

  if (!brand) return null;

  const DefaultInviteFriendsInstructions = () => (
    <>
      <div className={style[brand]}>
        <hr className={style.horizontalLine} />
        <div
          className={cn(style[brand], {
            [style.pickMealsVerticalLine]: isPickYourMeals,
          })}
        ></div>
        <div className="flex flex-col items-center pb-32 pt-8">
          <div className="w-[26rem]">
            <Heading brandStylesOverrides="h3" className="text-center">
              Invite friends, get free food!
            </Heading>
            <div className="flex flex-col">
              <div className="mt-8 flex gap-4">
                <Gift svgSize={ICON_SIZES.LG} className="flex-shrink-0" />
                <div className="pb-4">
                  <Text brandStylesOverrides="h5">Give The Gift Of Food</Text>
                  <Text className="text-charcoal-90">{giveToFriendText}</Text>
                </div>
              </div>
              <div className="flex gap-4">
                <Enjoy svgSize={ICON_SIZES.LG} />
                <div className="pb-4">
                  <Text brandStylesOverrides="h5">And Get Free Food For You</Text>
                  <Text className="text-charcoal-90">
                    When a friend signs up, you get {referralAmountFormatted} in credit, too!
                  </Text>
                </div>
              </div>
              <div className="flex gap-4">
                <Chat svgSize={ICON_SIZES.LG} />
                <div className="w-full pb-2">
                  <Text brandStylesOverrides="h5">A Cooking Community</Text>
                  <Text className="text-charcoal-90">
                    Cooking is more fun with friends! Send pics of your meals to a friend or post
                    'em to the gram and tag {brandData(brand).instagramHandle}.
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return isSmartphoneScreenSize ? (
    <SmartphoneInviteFriendsInstructions
      giveToFriendText={giveToFriendText}
      isSmartphoneScreenSize={isSmartphoneScreenSize}
      referralAmountFormatted={referralAmountFormatted}
    />
  ) : (
    <DefaultInviteFriendsInstructions />
  );
};

InviteFriendsInstructions.propTypes = {
  isSmartphoneScreenSize: PropTypes.bool,
  isPickYourMeals: PropTypes.bool,
};

export default InviteFriendsInstructions;
